export default "__VITE_ASSET__KvOE5bB6__"